

















































































































































































































import { Validator } from "vee-validate";
import { useThemeStore } from "@/shared/store/theme";
import Checkbox from "@/shared/components/ui/Checkbox.vue";
import Button from "@/shared/components/ui/Button.vue";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import { IndividualSignup, HealthPlanType } from "@/shared/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useUserStore } from "@/shared/store/user";
import { useSignUpStore } from "@/employee/store/signup";
import { SignupVerifyEmail as VerifyEmailRouteName } from "@/employee/route-names";
import HsaBankOnboardingFooter from "@/employee/components/shared/HsaBankOnboardingFooter.vue";
import * as HsaBankConstants from "@/shared/hsabConstants";
import { Route } from "vue-router";
import { domain as hsaBankDomain } from "@/shared/hsaBankUrls";

@Component({
  components: {
    Checkbox,
    Button,
    LoginWrapper,
    HsaBankOnboardingFooter,
    GenericLoadingSpinner
  }
})
export default class IndividualSignups extends Vue {
  $validator: Validator;
  signupStore = useSignUpStore();
  portalCustomizationStore = usePortalCustomizationStore();
  userStore = useUserStore();
  themeStore = useThemeStore();

  formModel: IndividualSignup = null;
  submitting = false;
  createAccountCompleted = false;
  confirmEmail = "";
  accountAlreadyConfirmed = false;
  questionnaireSubmitted = false;

  yesOrNoOptions = [
    { text: "Select your answer", value: null },
    { text: "Yes", value: true },
    { text: "No", value: false }
  ];

  healthPlanOptions = [
    { text: "Select your answer", value: HealthPlanType.Unknown },
    { text: "High-deductible health plan", value: HealthPlanType.Hdhp },
    { text: "Bronze plan or equivalent", value: HealthPlanType.Bronze },
    { text: "Catastrophic plan", value: HealthPlanType.Catastrophic },
    { text: "Other", value: HealthPlanType.Other }
  ];

  @Prop() routeToLogin;

  @Prop()
  partner: number;

  @Watch("signupPartnerId")
  loadTheme (): void {
    this.themeStore.getTheme({ partnerId: this.signupPartnerId, employerId: 0, forceUpdate: true });
  }

  get displayOnboardingFooter (): boolean {
    return this.signupPartnerId === HsaBankConstants.HsaBankRetailPartnerId;
  }

  get confirmEmailValidation () {
    return {
      required: !!this.formModel.email,
      confirmed: !!this.confirmEmail && this.formModel.email
    };
  }

  get signupPartnerId (): number {
    return this.partner ? this.partner : HsaBankConstants.HsaBankRetailPartnerId;
  }

  mounted () {
    this.questionnaireSubmitted = this.signupStore.hasQuestionnaireData;
    this.formModel.enrollmentReferralCodes = this.mapQueryStringParametersToEnrollmentReferralCodes(this.$route.query);
    this.loadTheme();
  }

  created () {
    if (!this.formModel) {
      this.formModel = this.signupStore.individualSignupState;
    }
  }

  goToHomepage () {
    window.location.replace(`https://${hsaBankDomain}`);
  }

  isSubmitDisabled () {
    return this.submitting || !this.portalCustomizationStore.isSupportInfoLoaded;
  }

  onSubmitQuestionnaire () {
    this.$validator.validateAll()
      .then(isValid => {
        if (isValid) {
          this.questionnaireSubmitted = true;
        }
      });
  }

  onContinue () {
    this.submitting = true;
    this.accountAlreadyConfirmed = false;

    this.$validator.validateAll()
      .then(isValid => {
        if (!isValid) {
          this.submitting = false;
          return;
        }

        this.formModel.partnerId = this.signupPartnerId;

        this.signupStore.signupIndividual(this.formModel)
          .then(response => {
            this.accountAlreadyConfirmed = !response.invitationSent;

            if (this.accountAlreadyConfirmed) {
              return;
            }

            this.signupStore.setEnrollmentDetails(this.formModel);
            this.createAccountCompleted = true;
            this.$router.push({ name: VerifyEmailRouteName });
          })
          .catch(() => {/*noop*/})
          .finally(() => {
            this.submitting = false;
        });
      });
  }

  mapQueryStringParametersToEnrollmentReferralCodes (queryStringParams: Route["query"]): Record<string, string | (string | null)[]> {
    const result: Record<string, string | (string | null)[]> = {};

    for (const [key, value] of Object.entries(queryStringParams)) {
      if (Array.isArray(value)) {
        result[key.toLocaleLowerCase()] = value;
      }
      else {
        result[key.toLocaleLowerCase()] = [value];
      }
    }

    return result;
  }

  goBackToLetsGetStarted () {
    this.questionnaireSubmitted = false;
  }
}
